import { Tag } from "primereact/tag";
import React from "react";
import { ReportJobBatchEntry } from "../../../client/types.gen";
import styles from "../cat/CatCard.module.css";
import { enhancedLabel } from "../cat/types";

// The vendor source a rater run rates under. Absent on broker-data runs.
export const RaterEnrichmentTag: React.FC<{ job: ReportJobBatchEntry }> = ({
  job,
}) => {
  const source = job.jobs[0]?.cat_metadata?.enrichment_source;
  if (!source) return null;
  return (
    <Tag
      value={enhancedLabel(source)}
      severity="info"
      className={styles.modelTag}
    />
  );
};
